export default function processErrors(errors) {
  let errorObject = {}
  for (let key in errors) {
    errorObject[key] = errors[key].shift()
  }
  return errorObject
}
